import { jsxs, jsx } from 'react/jsx-runtime';
import { useNavigation } from 'react-day-picker';
import { IconLeftCaret, IconRightCaret } from '@belong/icons';
import { format } from 'date-fns';
import { Button } from '../Button/Button.js';
import { Text } from '../Text/Text.js';

function Caption({
  displayMonth,
  onChange
}) {
  const {
    previousMonth,
    nextMonth,
    goToMonth
  } = useNavigation();
  const date = format(displayMonth, 'LLL');
  function goToNextMonth() {
    if (nextMonth) {
      goToMonth(nextMonth);
      typeof onChange === 'function' && onChange(nextMonth);
    }
  }
  function goToPrevMonth() {
    if (previousMonth) {
      goToMonth(previousMonth);
      typeof onChange === 'function' && onChange(previousMonth);
    }
  }
  return jsxs("div", {
    className: "mx-2xs mb-sm flex justify-between border-0 border-b border-solid border-gray pb-xs md:mx-xs",
    children: [jsx(Text, {
      fontWeight: "semibold",
      className: "m-0",
      children: "Select Date"
    }), jsxs("div", {
      className: "flex",
      children: [jsx(Button, {
        onClick: goToPrevMonth,
        variant: "text",
        size: "small",
        children: jsx(IconLeftCaret, {
          height: 14
        })
      }), jsx("span", {
        className: "mx-sm",
        children: `${date}, ${displayMonth.getFullYear()}`
      }), jsx(Button, {
        onClick: goToNextMonth,
        variant: "text",
        size: "small",
        children: jsx(IconRightCaret, {
          height: 14
        })
      })]
    })]
  });
}

export { Caption };
